import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import { sidebarStorage } from "~/utils/sidebar-storage";

export const useSignOut = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();

  const signOut = async () => {
    sidebarStorage.lockWrites();
    await queryClient.cancelQueries();
    sidebarStorage.clear();
    try {
      await auth.signoutRedirect();
    } catch (error) {
      console.error("Sign-out redirect failed, clearing local session:", error);
      queryClient.clear();
      await auth.removeUser();
      return false;
    }
    return true;
  };
  return { signOut };
};
